import Link from 'next/link';
import { useRouter } from 'next/router';
import React from 'react';

import { CDN_URL } from '../../../../utils/assets';

export interface AuthNavigationBarItem {
  label: string;
  url: string;
}

export interface AuthNavigationBarProps {
  items?: Array<AuthNavigationBarItem>;
  children?: React.ReactNode;
}

const AuthNavigationBar: React.FunctionComponent<AuthNavigationBarProps> = ({
  items = [{ label: 'Sign In', url: '/signin' }],
  children
}) => {
  const router = useRouter();

  return (
    <div className='z-600 relative flex h-16 min-w-full flex-row items-center bg-white px-8 shadow-md'>
      <div className='flex flex-row items-center'>
        <Link href='/' className='flex items-center'>
          <img width='96' src={`${CDN_URL}/images/logo/black@2x.png`} alt='Colony Logo' />
        </Link>
      </div>
      <div className='flex flex-row items-center'>
        {items?.map((item: AuthNavigationBarItem) => (
          <Link href={item && item.url ? item.url : '#'} key={item.url}>
            <span className='ml-12 cursor-pointer text-sm font-semibold text-slate-900 hover:text-indigo-600'>{item.label}</span>
          </Link>
        ))}
      </div>
      {children}
    </div>
  );
};

export default AuthNavigationBar;
